define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/data/AbstractPathBrowserStore",
	"csi/data/AbstractPathBrowserStoreOptions",
	"csi/def",
	"csi/locale",
	"csi/xml"
], function(array, declare, AbstractPathBrowserStore, AbstractPathBrowserStoreOptions, def, locale, xml) {

	var _omitMasterAttributes = {
		"ModifiedAt": 1,
		"ModifiedBy": 1
	};

	return declare(AbstractPathBrowserStoreOptions,
		{
			// the function accepting the store item and returning true if we want to keep this item in the store
			filterItem: function(item) {
				var ra = item.ra;

				//DE29944: there are two "Modified" attributes displayed - Document.Modified and DocumentRevision.Modified. Display only DocumentRevision.Modified
				if (_omitMasterAttributes[item.ra.getId()] && item.rc.isMaster())
					return false;
				return !ra || (ra.isEnabled && !ra.isHidden);
			}
		}
	);
});